import { Component } from '@angular/core';

@Component({
  selector: 'app-trash-icon',
  standalone: true,
  templateUrl: './trash-icon.component.html',
})
export class TrashIconComponent {}
